module.exports = __webpack_public_path__ + "img/topbottompanelreveal.ddecec6a.png";